import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiBaseService } from '../api-base.service';
import { AppGlobals } from 'src/app/app.globals';

@Injectable({
  providedIn: 'root',
})
export class ContractConfigService {
  private contractTypesSubject = new BehaviorSubject<any[]>([]);
  contractTypes$ = this.contractTypesSubject.asObservable();

  private deadlineTypeSubject = new BehaviorSubject<any[]>([]);
  deadlineType$ = this.deadlineTypeSubject.asObservable();

  constructor(private apiBaseService: ApiBaseService) {}

  async getContractConfig(payload: any): Promise<void> {
    try {
      const response = await this.apiBaseService.httpRequest('ConfigService/GetContractConfig', payload, true, true);

      if (response.hasError) {
        AppGlobals.ShowErrorMessage(response.feedback);
        return;
      }
      this.contractTypesSubject.next(response.contractTypes || []);
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
      this.contractTypesSubject.next([]);
    }
  }

  async saveContractType(payload: any): Promise<void> {
    try {
      const response = await this.apiBaseService.httpRequest('ConfigService/SaveContractType', payload, true, true);
      if (response.hasError) {
        AppGlobals.ShowErrorMessage(response.feedback);
        return;
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  async deleteContractType(payload: any): Promise<void> {
    try {
      const response = await this.apiBaseService.httpRequest('ConfigService/DeleteContractType', payload, true, true);
      if (response.hasError) {
        AppGlobals.ShowErrorMessage(response.feedback);
        return;
      }
      await this.getContractConfig({});
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  async getContractDeadlineTypes(payload: any): Promise<void> {
    try {
      const response = await this.apiBaseService.httpRequest('ConfigService/GetDeadlineTypes', payload, true, true);
      if (response.hasError) {
        AppGlobals.ShowErrorMessage(response.feedback);
        return;
      }
      this.deadlineTypeSubject.next(response.contractDeadlineTypes || []);
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
      this.deadlineTypeSubject.next([]);
    }
  }

  async saveContractDeadlineType(payload: any): Promise<void> {
    try {
      const response = await this.apiBaseService.httpRequest('ConfigService/SaveDeadlineType', payload, true, true);
      if (response.hasError) {
        AppGlobals.ShowErrorMessage(response.feedback);
        return;
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  async deleteContractDeadlineType(payload: any): Promise<void> {
    try {
      const response = await this.apiBaseService.httpRequest('ConfigService/DeleteDeadlineType', payload, true, true);
      if (response.hasError) {
        AppGlobals.ShowErrorMessage(response.feedback);
        return;
      }
      await this.getContractDeadlineTypes({});
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  /************* Review Settings *************/

  async getContractReviewSettings(): Promise<any> {
    try {
      const response = await this.apiBaseService.httpRequest('ConfigService/GetContractReviewSettings', {}, true, true);
      if (response.hasError) {
        AppGlobals.ShowErrorMessage(response.feedback);
        return null;
      }
      return response.settings ?? null;
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
      return null;
    }
  }

  async saveContractReviewSettings(settings: any): Promise<boolean> {
    try {
      const response = await this.apiBaseService.httpRequest(
        'ConfigService/SaveContractReviewSettings',
        { Settings: settings },
        true,
        true
      );
      if (response.hasError) {
        AppGlobals.ShowErrorMessage(response.feedback);
        return false;
      }
      return true;
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
      return false;
    }
  }
}
